/* Detect product review stars from YOTPO APP */
/*  layout/theme.liquid, sections/main-product.liquid*/
document.addEventListener("DOMContentLoaded", function () {


  function whenAvailable(DOM_element, callback, number_of_trys) {
    number_of_trys += 1;
    const appEl = document.querySelector(DOM_element);
    const interval = 1000;

    console.log(number_of_trys);
    const int = window.setTimeout(function () {
      if (appEl) {
        callback(appEl);
        clearInterval(int);
      } else {
        number_of_trys <= 10
          ? whenAvailable(DOM_element, callback, number_of_trys)
          : console.log("Reached limit for number_of_trys", number_of_trys);
      }
    }, interval);
  }

  whenAvailable(
    ".yotpo-reviews-star-ratings-widget",
    function (el) {
      //console.log("App fully loaded", el)

      const container = document.querySelector("[data-js-reviews-container]");
      if (!container) {
        return console.log("Cant find container for updating element position");
      }
      container.appendChild(el);
      el.classList.add("loaded");
    },
    0
  );
});
